module.exports = __webpack_public_path__ + "img/congratulations.495d97be.svg";